export default "<csn-livespins-schedule-room [liveScheduledStream]=\"livespinsScheduleRoom\" [cta]=\"true\"></csn-livespins-schedule-room>"